// ** React Imports
import { Fragment } from 'react'

// ** Third Party Components
import { ArrowRight } from 'react-feather'
import { useForm } from 'react-hook-form'
import FileUploaderMultiple from '../FileUploader'
import Typography from '@mui/material/Typography'
import { useOnboarding } from '../OnboardingContext'
import { useTranslation } from 'react-i18next'

// ** Reactstrap Imports
import { Row, Col, Button, Form } from 'reactstrap'
import FileWorker from './FileWorker'
import Slide from '@mui/material/Slide'

const DSN = ({ stepper }) => {
  // ** Hooks
  const {
    setError,
    handleSubmit
  } = useForm()

  const { filesCurrentAction, updateLatestStep, setFilesCurrentAction, files } = useOnboarding()

  const onSubmit = data => {
    if (files.length === undefined || files.length === 0) {
      console.log("skipped")
      setFilesCurrentAction('skipped')
      updateLatestStep(2)
      stepper.next()
    } else if (Object.values(data).every(field => field.length > 0)) {
      updateLatestStep(2)
      stepper.next()
    } else {
      for (const key in data) {
        if (data[key].length === 0) {
          setError(key, {
            type: 'manual',
            message: `Please enter a valid ${key}`
          })
        }
      }
    }
  }

  const { t } = useTranslation()

  return (
    <Fragment>
      <div className='content-header'>
        <h5 className='mb-0'>DSN</h5>
        <small>{t("DSN-header")}</small>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md='12' className='mb-1'>
            {
              (filesCurrentAction === "idle" && <FileUploaderMultiple />) ||
              <div style={{ maxHeight: '60vh', overflow: 'scroll' }}>
                <FileWorker />
              </div>
            }
          </Col>
        </Row>
        {(filesCurrentAction === "idle" && 
        <div className='d-flex justify-content-end'>
          <Button type='submit' color='primary' className='btn-next'>
            <span className='align-middle d-sm-inline-block d-none'>{t('skip')}</span>
            <ArrowRight size={14} className='align-middle ms-sm-25 ms-0' />
          </Button>
          </div>)
        ||
        <div className='d-flex justify-content-end'>
          <div style={{display: 'flex'}}>
            <Slide direction="right" in={filesCurrentAction !== "idle"} style={{ transitionDelay: '200ms' }} timeout={{ appear: 2000, enter: 1000, exit: 500 }}>
              <div>
                <img src="assets/ozp-trans-logo-medium.png" style={{width:"40px"}}/>
                <Typography variant='caption' sx={{ mb: 1, color: 'primary', mr: 2 }} fontSize='15px'>
                    {t("DSN-next-message")}
                    <ArrowRight size={14} className='align-middle ms-sm-25 ms-0'></ArrowRight>
                </Typography>
                <Button type='submit' color='primary' className='btn-next'>
                  <span className='align-middle d-sm-inline-block d-none'>{t('next')}</span>
                  <ArrowRight size={14} className='align-middle ms-sm-25 ms-0'></ArrowRight>
                </Button>
              </div>
            </Slide> 
          </div>
        </div>
      }
      </Form>
    </Fragment>
  )
}

export default DSN
